import api from "..";
import { isSuccessResponseStatusCode } from "../handler";
import { GenerateSmsData, VerifySmsData, GenerateSmsResultData } from "./types";

export const $generateSms = async (
	body: GenerateSmsData
): Promise<GenerateSmsResultData | null> => {
	// mock | generate sms
	// const response = {
	// 	id: 1
	// };

	// console.log('POST /customer-verifier/generate-sms', body, response);

	// return response;

	return api
		.post('customer-verifier/generate-sms', body);
};

export const $verifySms = async (
	body: VerifySmsData
): Promise<boolean> => {
	// mock | verify sms
	// const response = true;

	// console.log('POST /customer-verifier/check-sms', body, response);

	// return true;

	return api
		.post('customer-verifier/check-sms', body, {
			handler: { returnData: false }
		})
		.then(response => isSuccessResponseStatusCode(response.status));
};